module.exports = __webpack_public_path__ + "static/media/roble_alaska.1f4ea660.jpg";